/**
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */

import moment from "moment-timezone";

const dateFormatTokenMapping = new Map([
  ["MMMMM", "F"],
  ["MMM", "M"],
  ["MM", "m"],
  ["yyyy", "Y"],
  ["yy", "y"],
  ["dd", "d"],
]);

export const getCarbonDateFormat = (dateFormat) => {
  if (typeof dateFormat !== "string") return null;
  dateFormatTokenMapping.forEach((value, key) => {
    const index = dateFormat.indexOf(key);
    if (index !== -1) {
      dateFormat = dateFormat.replace(key, value);
    }
  });

  return dateFormat;
};

export function formatDateTime(
  dateTime,
  timezone,
  tririgaDateTimeFormat,
  userLanguageCode
) {
  if (!dateTime) return "";
  const momentFormat = convertTririgaDateFormatToMomentFormat(
    tririgaDateTimeFormat,
    "MM/dd/yyyy HH:mm"
  );
  const parsedDate = moment(dateTime);
  parsedDate.tz(timezone != null ? timezone : moment.tz.guess());

  if (userLanguageCode != null) {
    parsedDate.locale(userLanguageCode);
  }
  return parsedDate.format(momentFormat);
}

export function formatDate(date, tririgaDateFormat, locale) {
  if (!date) return "";
  const momentFormat = convertTririgaDateFormatToMomentFormat(
    tririgaDateFormat
  );

  const parsedDate = moment.parseZone(date);
  if (locale) {
    parsedDate.locale(locale);
  }
  return parsedDate.format(momentFormat);
}

export function convertTririgaDateFormatToMomentFormat(
  format,
  defaultFormat = "MM/dd/yyyy"
) {
  let convertedFormat = format != null ? format : defaultFormat;
  convertedFormat = convertedFormat.replace("dd", "DD");
  convertedFormat = convertedFormat.replace("MMMMM", "MMMM");
  convertedFormat = convertedFormat.replace(/y/g, "Y");
  convertedFormat = convertedFormat.replace("zzz", "zz");
  let start = false;
  return convertedFormat.replace(/'/g, () => {
    start = !start;
    return start ? "[" : "]";
  });
}
